import {
  Accordion,
  AccordionSummary,
  Box,
  Container,
  Fade,
  Grid,
  Paper,
  styled,
  accordionClasses,
  accordionDetailsClasses,
  Typography,
  AccordionDetails,
  Card,
  CardHeader,
  CardContent,
  InputLabel,
  FormHelperText,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { axiosClient } from "../AxiosClient";
import { useParams } from "react-router-dom";
import { Button } from "@material-ui/core";
import CamIcon from "@mui/icons-material/CameraAlt";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const Downnload = styled("a")({
  flexGrow: 0,
  padding: "10px 20px !important",
  borderRadius: "20px !important",
  gap: "10px !important",
  backgroundColor: "#161e55 !important",
  color: "#ffff !important",
  textDecoration: "none !important",
  margin: "0px 1rem !important",
  "&:hover": {
    backgroundColor: "#A8C8AF !important",
  },
});

const ButtonImage = styled(Button)({
  flexGrow: 0,
  borderRadius: "20px",
  gap: "10px",
  backgroundColor: "#ffff",
  color: "#161e55",
  margin: "0px 1rem",
  border: "1px solid rgba(11, 10, 10, 0.17)",
  "&:hover": {
    backgroundColor: "#A8C8AF",
  },
});

const ButtonAdd = styled(Button)({
  flexGrow: 0,
  borderRadius: "20px",
  gap: "10px",
  backgroundColor: "#161e55",
  color: "#ffff",
  margin: "0px 1rem",
  "&:hover": {
    backgroundColor: "#A8C8AF",
  },
});

const TextMessage = styled(FormHelperText)({
  color: "green",
});

const titles = ["Documento Identidad", "Pagaré", "Informe TusDatos"];

const MAX_INVOICE_FILE_SIZE_MB = 10;
const MAX_INVOICE_FILE_SIZE_BYTES = MAX_INVOICE_FILE_SIZE_MB * 1024 * 1024;

const uploadImage = (keyImage, setImage, extension = ".jpg") => {
  // Validar que keyImage no sea null
  if (!keyImage || keyImage === "null" || keyImage === "undefined") {
    console.log(`uploadImage: keyImage is invalid: ${keyImage}`);
    setImage(null);
    return;
  }

  axiosClient
    .get(`/v1/s3/url/${keyImage}${extension}`)
    .then((response) => {
      setImage(response.data);
    })
    .catch((error) => {
      console.log(`uploadImage error for ${keyImage}:`, error.message);
      setImage(null);
    });
};

const uploadImagePDF = (keyImage, setImage) => {
  // Validar que keyImage no sea null
  if (!keyImage || keyImage === "null" || keyImage === "undefined") {
    console.log(`uploadImagePDF: keyImage is invalid: ${keyImage}`);
    setImage(null);
    return;
  }

  axiosClient
    .get(`/v1/s3/url/pdf/${keyImage}.pdf`)
    .then((response) => {
      console.log(response.data);
      setImage(response.data);
    })
    .catch((error) => {
      console.log(`uploadImagePDF error for ${keyImage}:`, error.message);
      setImage(null);
    });
};

const searchClient = (clientUuid, setClient) => {
  axiosClient
    .get(`/v1/clients/${clientUuid}`)
    .then((response) => {
      console.log("Client data received:", response.data);
      setClient(response.data);
    })
    .catch((error) => {
      console.log("Error fetching client data:", error.message);
      setClient(null);
    });
};

const saveInvoice = (
  clientUuid,
  invoice,
  setNewInvoice,
  setSnackbar,
  setSeverity,
  setMessage,
  setIsInvoice,
  setIsBackdrop,
) => {
  const selectedFile = invoice?.current?.files?.[0];

  if (!selectedFile) {
    setSeverity("warning");
    setMessage("Selecciona una factura antes de guardar");
    setIsInvoice(false);
    setSnackbar(true);
    return;
  }

  const invoiceDocument = new FormData();
  invoiceDocument.append("image", selectedFile);
  setIsBackdrop(true);
  axiosClient
    .post(`/v1/s3/upload-invoice/${clientUuid}`, invoiceDocument)
    .then((response) => {
      console.log(response.status);
      if (response.status === 200) {
        setNewInvoice(Math.random());
        setSeverity("success");
        setMessage("Factura cargada correctamente");
        setIsInvoice(false);
        setSnackbar(true);
        return;
      } else {
        setSeverity("error");
        setMessage("Error al cargar la factura");
        setIsInvoice(false);
        setSnackbar(true);
        throw new Error("Error upload images in client");
      }
    })
    .catch((error) => {
      setSeverity("error");
      setMessage(
        error.response?.status === 413
          ? `El archivo supera el tamaño máximo permitido de ${MAX_INVOICE_FILE_SIZE_MB} MB`
          : "Error al cargar la factura",
      );
      setIsInvoice(false);
      setSnackbar(true);
      console.log("Error with Axios: " + error.message);
    })
    .finally(() => {
      setIsBackdrop(false);
    });
};

export default function Information() {
  const [expanded, setExpanded] = useState(true);
  const [client, setClient] = useState();
  const { clientUuid } = useParams();
  const [urlImgFront, setUrlImgFront] = useState("");
  const [urlImgPosterior, setImgPosterior] = useState("");
  const [truora, setTruora] = useState("");
  const [urlZapsign, setUrlZapsign] = useState("");
  const [urlExperian, setUrlExperian] = useState("");
  const [urlTusDatos, setUrlTusDatos] = useState("");
  const [urlFactura, setUrlFactura] = useState("");
  const invoice = useRef(null);
  const [isInvoice, setIsInvoice] = useState(false);
  const [newInvoice, setNewInvoice] = useState("");
  const [isBackdrop, setIsBackdrop] = useState(false);
  const [isSnackbar, setIsSnackbar] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");

  const pdfFilePath =
    "https://prami-prod-col.s3.us-east-2.amazonaws.com/00007d8e-cd69-4431-be42-b1b8b4ed8179.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20250422T213157Z&X-Amz-SignedHeaders=host&X-Amz-Expires=899&X-Amz-Credential=AKIATIG4PWRCIIH3YHWX%2F20250422%2Fus-east-2%2Fs3%2Faws4_request&X-Amz-Signature=4e2b83a6b58b58c6b352dfee0b28bb2472da56ae547a5ffcaaa94d65e529a1f4"; // Reemplaza con la ruta de tu archivo PDF

  const handleExpansion = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  const handleChangeInvoice = () => {
    const selectedFile = invoice?.current?.files?.[0];

    if (!selectedFile) {
      setIsInvoice(false);
      return;
    }

    if (selectedFile.size > MAX_INVOICE_FILE_SIZE_BYTES) {
      invoice.current.value = "";
      setSeverity("error");
      setMessage(
        `El archivo supera el tamaño máximo permitido de ${MAX_INVOICE_FILE_SIZE_MB} MB`,
      );
      setIsInvoice(false);
      setIsSnackbar(true);
      return;
    }

    setIsInvoice(true);
  };

  const handleClosedSnack = () => {
    setIsSnackbar(false);
    setMessage("");
  };

  useEffect(() => {
    searchClient(clientUuid, setClient);
  }, [newInvoice]);

  useEffect(() => {
    if (client) {
      uploadImage(client?.frontDocumentUuid, setUrlImgFront);
      uploadImage(client?.backDocumentUuid, setImgPosterior);
      uploadImage(client?.selfieUuid, setTruora);
      uploadImagePDF(client?.pagareZapsignUuid, setUrlZapsign);
      uploadImagePDF(client?.tusDatosUuid, setUrlTusDatos);
      uploadImagePDF(client?.experianUuid, setUrlExperian);
      uploadImage(client?.invoiceUuid, setUrlFactura, "");
    }
  }, [client]);

  return (
    <React.Fragment>
      <br></br>
      <Box sx={{ width: "100%", marginTop: "1.9rem", marginBottom: "1rem" }}>
        <Container>
          <Item></Item>
          <Item>.</Item>
          <Grid container marginTop={2} alignItems={"center"}>
            <h1>Documentación Clientes</h1>
            <Grid sx={{ width: "100%" }} marginTop={2}>
              <Accordion
                expanded={expanded}
                onChange={handleExpansion}
                slots={{ transition: Fade }}
                slotProps={{ transition: { timeout: 400 } }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Typography component="h2" sx={{ fontWeight: "bold" }}>
                    Documento Identidad
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" },
                    gap: 4,
                    p: 4,
                    backgroundColor: "rgba(250, 250, 250, 0.7)",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05) inset",
                  }}
                >
                  {[
                    {
                      img: urlImgFront,
                      label: "Imagen Frontal",
                      alt: "documento-frontal",
                    },
                    {
                      img: urlImgPosterior,
                      label: "Imagen Trasera",
                      alt: "documento-posterior",
                    },
                    { img: truora, label: "Selfie", alt: "fotografia-selfie" },
                  ].map((item, index) => (
                    <Card
                      key={index}
                      sx={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        borderRadius: "12px",
                        overflow: "hidden",
                        transition:
                          "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.1)",
                        boxShadow: "0 6px 16px rgba(0, 0, 0, 0.12)",
                        "&:hover": {
                          transform: "translateY(-8px)",
                          boxShadow: "0 12px 28px rgba(0, 0, 0, 0.2)",
                        },
                      }}
                    >
                      <CardHeader
                        title={item.label}
                        titleTypographyProps={{
                          variant: "subtitle1",
                          align: "center",
                          fontWeight: 600,
                          color: "#161e55",
                        }}
                        sx={{
                          py: 2,
                          bgcolor: "background.default",
                          borderBottom: "1px solid",
                          borderColor: "divider",
                        }}
                      />

                      <CardContent
                        sx={{
                          flex: 1,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          p: 2,
                          bgcolor: "background.paper",
                          position: "relative",
                          "&::after": {
                            content: '""',
                            position: "absolute",
                            inset: 0,
                            background:
                              "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)",
                            pointerEvents: "none",
                          },
                        }}
                      >
                        {item.img ? (
                          <img
                            src={item.img}
                            alt={item.alt}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                              borderRadius: "6px",
                            }}
                          />
                        ) : (
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ textAlign: "center", padding: "20px" }}
                          >
                            Documento no disponible
                          </Typography>
                        )}
                      </CardContent>
                    </Card>
                  ))}
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2-content"
                  id="panel2-header"
                >
                  <Typography component="h2" sx={{ fontWeight: "bold" }}>
                    Pagaré
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={{ textAlign: "center", paddingBottom: "2rem" }}
                >
                  {urlZapsign ? (
                    <iframe
                      src={urlZapsign}
                      width="100%"
                      height="600px"
                      title="Visor de PDF sin barra de herramientas"
                      loading="lazy"
                    ></iframe>
                  ) : (
                    <Typography
                      variant="body1"
                      color="text.secondary"
                      sx={{ textAlign: "center", padding: "40px" }}
                    >
                      Pagaré no disponible
                    </Typography>
                  )}
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2-content"
                  id="panel2-header"
                >
                  <Typography component="h2" sx={{ fontWeight: "bold" }}>
                    Informe TusDatos
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={{ textAlign: "center", paddingBottom: "2rem" }}
                >
                  {urlTusDatos ? (
                    <iframe
                      src={urlTusDatos}
                      width="100%"
                      height="600px"
                      title="Visor de PDF sin barra de herramientas"
                      loading="lazy"
                    ></iframe>
                  ) : (
                    <Typography
                      variant="body1"
                      color="text.secondary"
                      sx={{ textAlign: "center", padding: "40px" }}
                    >
                      Informe TusDatos no disponible
                    </Typography>
                  )}
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2-content"
                  id="panel2-header"
                >
                  <Typography component="h2" sx={{ fontWeight: "bold" }}>
                    Experian
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={{ textAlign: "center", paddingBottom: "2rem" }}
                >
                  {urlExperian ? (
                    <iframe
                      src={urlExperian}
                      width="100%"
                      height="600px"
                      title="Visor de PDF sin barra de herramientas"
                      loading="lazy"
                    ></iframe>
                  ) : (
                    <Typography
                      variant="body1"
                      color="text.secondary"
                      sx={{ textAlign: "center", padding: "40px" }}
                    >
                      Informe Experian no disponible
                    </Typography>
                  )}
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2-content"
                  id="panel2-header"
                >
                  <Typography component="h2" sx={{ fontWeight: "bold" }}>
                    Factura
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={{ textAlign: "center", paddingBottom: "2rem" }}
                >
                  <Box
                    mt={5}
                    mb={2}
                    display={"flex"}
                    justifyContent={"center"}
                    alignItems={"center"}
                  >
                    {/* <FormControl sx={{width: '65%'}}> */}
                    {isInvoice && (
                      <TextMessage sx={{ marginLeft: "1rem" }}>
                        Imagen cargada
                      </TextMessage>
                    )}
                    <ButtonImage onClick={(e) => invoice.current?.click()}>
                      <input
                        accept="image/*,application/pdf"
                        type="file"
                        multiple
                        hidden
                        ref={invoice}
                        onChange={handleChangeInvoice}
                      ></input>
                      Cargar documento
                      <CamIcon sx={{ marginLeft: "1rem" }}></CamIcon>
                    </ButtonImage>
                    <ButtonAdd
                      onClick={() =>
                        saveInvoice(
                          client?.uuid,
                          invoice,
                          setNewInvoice,
                          setIsSnackbar,
                          setSeverity,
                          setMessage,
                          setIsInvoice,
                          setIsBackdrop,
                        )
                      }
                    >
                      Guardar
                    </ButtonAdd>
                    <Downnload href={urlFactura} target="_blank">
                      VER DOCUMENTO
                    </Downnload>
                    {/* </FormControl> */}
                  </Box>
                </AccordionDetails>
              </Accordion>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Backdrop
        sx={{
          background: "rgba(255,255,255,0.1)",
          zIndex: "5",
          width: "50%",
          margin: "auto auto auto 30vw",
        }}
        open={isBackdrop}
      >
        <CircularProgress color="success" />
      </Backdrop>
      <Snackbar
        open={isSnackbar}
        autoHideDuration={5000}
        onClose={handleClosedSnack}
      >
        <Alert
          onClose={handleClosedSnack}
          severity={severity}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </React.Fragment>
  );
}
